import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Service = () => {
  const [services, setServices] = useState([]);
  const [sectionTitle, setSectionTitle] = useState("Our Services");

  // Simulate fetching data from an API
  useEffect(() => {
    const fetchServices = async () => {
      // Imagine you're fetching data from an API
      const data = [
        { number: '01', img:   '/images/incorporation.png', link: '/incorporation', title: 'Incorporation', description: 'Our incorporation services guide you through the complexities of establishing a new business, ensuring all legal and regulatory requirements are met efficiently. We handle everything from initial registration structuring, providing a strong foundation for your business success.' },
        { number: '02', img:   '/images/accounting.png', link: '/accounting', title: 'Accounting', description: 'We offer comprehensive accounting services tailored to your business needs, including bookkeeping, financial statement preparation, and management reporting. Our meticulous approach ensures accuracy and compliance, giving you clear insights into your financial health.' },
        { number: '03', img:   '/images/taxation.jpg', link: '/taxation', title: 'Taxation', description: 'Navigating the complexities of tax regulations can be challenging. Our taxation services cover everything from tax planning and preparation to filing and advisory, ensuring compliance while optimizing your tax position and minimizing liabilities.' },
        { number: '04', img:   '/images/specialized-tax.png', link: '/specialized_tax-services', title: 'Specialized Tax Services', description: 'Our Specialized Tax Services cater to corporations, individuals, expatriates, and NRIs with unparalleled expertise. Whether your navigating corporate restructuring, ensuring compliance with international tax laws, or optimizing taxation strategies, we provide end-to-end support to meet your unique needs.'},

        { number: '05', img:   '/images/audit_icon.png', link: '/audit-and-assurance-services', title: 'Audit & Assurance', description: 'Our audit services ensure accuracy and compliance with regulatory standards through various audits, including statutory audit, tax audit, internal audit, concurrent audit, management audit, GST audit, fraud investigation audit, and information system audit. Our comprehensive approach helps identify areas for improvement, enhances financial integrity, and boosts stakeholder confidence.' },
        { number: '06', img:   '/images/consultant_services.png', link: '/consultancy-services', title: 'Consultancy Service', description: 'Our consultancy services provide strategic guidance and expert advice across various business needs, including management consultancy, financial advisory, IT consultancy, business feasibility studies, and transaction advisory. From financial planning to business transformation, we help you navigate challenges and seize opportunities, driving growth and success.' },
        { number: '07', img:   '/images/compliance.png', link: '/coming-soon', title: 'Corporate Compliance', description: 'Stay ahead of regulatory requirements with our corporate compliance services. We assist with corporate law, FEMA compliance, Foreign Trade Policy (FTP) compliance, US GAAP/IFRS conversion, business valuation, and mergers and acquisitions. Our expertise helps you navigate complex legal landscapes, ensuring smooth operations and minimizing risk.' },

        { number: '08', img:   '/images/cfo.png', link: '/coming-soon', title: 'Cfo Services', description: 'Our CFO services provide expert financial management without the need for a full-time hire. We handle business process setup, compliance, strategy, financial planning, budgeting, and MIS reporting to management. Acting as your virtual CFO, we ensure your financial records and statutory compliances are up-to-date, enhancing your financial effectiveness and driving business growth.' },
        { number: '09', img:   '/images/outsourcing.png', link: '/coming-soon', title: 'Outsourcing', description: 'Streamline your operations and reduce overheads with our outsourcing services. We handle back-office functions like payroll, HR, and accounting, allowing you to focus on core business activities. Whether you need auditors, tax professionals, or accountants, our team mirrors your processes, ensuring consistency, efficiency, and round-the-clock support for your business needs.' },
      ];
      setServices(data);
      if (data.length > 0) {
        setSectionTitle(`${data.length} Available Services`);
      }
    };

    fetchServices();
  }, []);

    // Define the handleButtonClick function
    const handleButtonClick = (link) => {
      if (link) {
         window.location.href = link; // Opens the link in the same tab
      } else {
        alert('No link available for this service');
      }
    };

  return (
    <div className='container' id='all_services'>
      <div className='row'>
        <div className='col-md-4 column_height'>
          <div className='section_main_title our_services'>
            <p>{sectionTitle}</p>
            <ul className='d-flex align-items-center'>
              <li className='green'>proactive </li>
              <li className='orange'>relevant</li>
              <li className='light-blue'>innovative</li>
            </ul>
            <h2>Comprehensive <span>Financial</span> Planning and Analysis</h2>
            <p>Simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
              standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it
              to make a type specimen book. It has survived not only five centuries,</p>
          </div>
        </div>
        <div className='col-md-8'>
            <div className='row mb-4'>
                {services.map((service, index) => (
                  <div className='col-lg-6 col-md-6 box_desing_wrapper our_services' key={index}>
                      <div className='inr_box'>
                        <div className='box-icon-text d-flex'>
                          <img src={service.img} alt={service.title} />
                          <h2>{service.title}</h2>
                        </div>
                        <p>{service.description}</p>
                        <button className="service-btn" onClick={() => handleButtonClick(service.link)}>
                          <i class="fas fa-chevron-right"></i>
                        </button>
                        <Link className='service-btn' to={service.link}>
                           <i class="fas fa-chevron-right"></i>
                        </Link>
                        <h5 className='number'>{service.number}</h5>
                      </div>
                  </div>
                ))}
            </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
